import { FormControl, TextField } from "@mui/material";
import styled from "styled-components";

export const InputSection = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  gap: 15px;

  align-items: center;
`;

export const InputText = styled(TextField)<{ $invalid?: boolean }>`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
    border-width: ${({ $invalid }) => ($invalid ? "2px" : undefined)};
  }
  & .MuiInputLabel-root.Mui-error {
    color: inherit;
  }
`;

/** Para Select (opcional): use se quiser estilizar FormControl da mesma forma */
export const RequiredFormControl = styled(FormControl)<{ $invalid?: boolean }>`
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ $invalid }) => ($invalid ? "#d32f2f" : undefined)};
    border-width: ${({ $invalid }) => ($invalid ? "2px" : undefined)};
  }
  & .MuiFormLabel-root.Mui-error {
    color: inherit;
  }
`;
